import { useContainer } from '../../useContainer';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { NoteActivity } from '../../../commonTypes/project.types';
import { useTranslation } from '../../useTranslation';

const useHttpPostNoteActivity = () => {
    const { t } = useTranslation('newNotifications');
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const execSubmit = (body: NoteActivity, callback: ICallback) => {
        const { exec, abort } = projectApi.createNoteActivity({
            body,
            onSuccess: res => {
                toastHandler.push('success', t('activity.noteActivityTitle'), t('activity.noteActivityMessage_Success'));
                if (callback.onSuccess) callback.onSuccess(res.body);
            },
            onError: _ => {
                toastHandler.push('error', t('activity.noteActivityTitle'), t('activity.noteActivityMessage_Failed'));
            },
        });

        exec();
        return abort;
    };

    return { execSubmit };
};

export default useHttpPostNoteActivity;
